/* eslint-disable */
import React, { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import withLocalization from '../hoc/withLocalization';
import { RootState } from '../../redux/rootReducer';
import { mappedSummaryData } from '../../util/orderSummaryMapping';
import { getMaskedCardInformationFromToken } from '../NewOfferCyberSource/paymentUtil';
import ParseHtml from '../common/ParseHtml';
import { replacePlaceholder } from '../../util/CommonLogic';
import './OrderSummaryDetails.scss';
import { capitalizeFirstLetter } from '../../util/CommonLogic';
import { CardSummary } from '../NewOfferCyberSource/types';
//import { useCountryCodeByName } from '../../util/useCountryCodeByName';
import isAsia from '../../util/isAsia';

interface tripInfolProps {
  localize?: any;
}
const InformationSummary: FC<tripInfolProps> = (props: tripInfolProps) => {
  const { localize } = props;

  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const pinPospectInfo: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const pinLeadDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFlowLeadInfo);
  const newOfferData = offerDetails;

  const flexToken = useSelector((state: RootState) => state.newOfferPaymentDetails.transientToken);
  const cardObj: CardSummary = flexToken && getMaskedCardInformationFromToken(flexToken);
  const cardDigit = cardObj?.maskedCardNumber?.slice(-4) || '';
  const cardName = cardObj?.cardName;
  // only show 'ending in' for CC payments
  const cardInfo = cardObj?.isCreditCard ? `${cardName} ending in ${cardDigit}` : `${cardName}`;
  //const dialCode: any = useCountryCodeByName(pinPospectInfo?.countryCode);
  const dialCode = pinLeadDetails?.dialCode || '';
  const dailCodeWithPhone = `${dialCode}${pinLeadDetails?.phone}`;
  const pinPhNo = pinPospectInfo?.phone || dailCodeWithPhone;
  const finalPhone = pinPhNo;
  const phNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');

  const callCenterCode = pinPospectInfo?.callCenterCode || '';
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.activationPhone`;
  const defaultActivePhone = localize('preview-sales-engine.static-content.copy.pbeo.default-activation-phone');
  const callCenterPhoneWithCode = localize(jahiaCallcenter) || phNo;
  const stPhone = `${callCenterPhoneWithCode}`;

  const orderInfo: any = mappedSummaryData(finalPhone, newOfferData);
  const PhoneNo = localize('preview-sales-engine.static-content.copy.pbeo.default-activation-phone');
  const datesContent = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-travel-dates-label');
  const updatedContent = replacePlaceholder(datesContent, '{months}', `${orderInfo?.dates}`);
  const bookContent = localize('preview-sales-engine.static-content.copy.pbeo.summary-dates-call-to-confirm');
  const maxguestContent = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-max-guests-label');
  const updatedMaxGuest = replacePlaceholder(maxguestContent, '{guests}', `${orderInfo?.maxGuest}`);
  const refineBookContent = replacePlaceholder(bookContent, '<p>', '');
  const finalContent = replacePlaceholder(refineBookContent, '</p>', '');
  const splitContent = finalContent?.split('{0}') || [];
  const callText = splitContent[0] || '';
  const travelText = (splitContent[1] && splitContent[1]?.trim()) || '';

  const phText = ` <a class="tripInfoDate-phone-wrapper" href={'tel:${PhoneNo}'}>${PhoneNo}</a>`;
  const tempData = replacePlaceholder(bookContent, '{0}', phText);
  const accommodationText = orderInfo?.accommodation || '';
  const updatedAccomodation = capitalizeFirstLetter(accommodationText);
  const stayText = localize('preview-sales-engine.static-content.copy.pbeo.package-overview-days-nights-label');
  const updatedDays = replacePlaceholder(stayText, '{days}', orderInfo?.days);
  const updatedStay = replacePlaceholder(updatedDays, '{nights}', orderInfo?.nights);
  const symbol = localize('preview-sales-engine.static-content.copy.pbeo.intl.usd-label');
  const totalPriceAmt = replacePlaceholder(orderInfo?.totalPrice, '$', symbol);
  const depositPaidAmt = replacePlaceholder(orderInfo?.depositPaid, '$', symbol);
  const balanceAmt = replacePlaceholder(orderInfo?.balance, '$', symbol);
  return (
    <>
      <div className="ord-sum-trip-info-section">
        <span className="tripInfo-title">
          {localize('preview-sales-engine.static-content.copy.pbeo.trip-information-label')}
        </span>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.summary-confirmation-number-label')}
          </span>
          <span className="tripInfo-content">{orderInfo?.locator}</span>
        </div>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-location-label')}
          </span>
          <span className="tripInfo-content">{orderInfo?.location}</span>
        </div>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head"> {localize('preview-sales-engine.static-content.copy.pbeo.stay-label')}</span>
          <span className="tripInfo-content">{updatedStay}</span>
        </div>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-accommodation-label')}
          </span>
          <span className="tripInfo-content">{updatedAccomodation} </span>
        </div>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.validity-label')}
          </span>
          <div className="tripInfoDate-text-container">
            <span className="tripInfo-content">
              <ParseHtml htmlInput={updatedContent}></ParseHtml>
            </span>

            <div className="tripInfoDate-phone-container">
              {/* <ParseHtml htmlInput={tempData}></ParseHtml>*/}
              <div className="travelDate-text-wrapper">
                <span className="tripInfoDate-call-wrapper">{callText}</span>
              </div>
              <div className="travelDate-text-wrapper">
                <a className="tripInfoDate-phone-wrapper" href={`tel:${stPhone}`}>
                  {`+${stPhone}`}
                </a>
              </div>
              <div className="travelDate-text-wrapper">
                <span className="tripInfo-content">{travelText}</span>
              </div>
              {/*<span className="tripInfoDate-phone-wrapper">{PhoneNo}</span>*/}
            </div>
          </div>
        </div>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.intl.capacity-label')}
          </span>
          <span className="tripInfo-content">{updatedMaxGuest}</span>
        </div>
        {orderInfo?.giftOpt && (
          <div className="tripInfo-row-container">
            <span className="tripInfo-head">
              {localize('preview-sales-engine.static-content.copy.pbeo.package-summary-gift-label')}
            </span>
            <span className="tripInfo-content">{orderInfo?.giftOpt}</span>
          </div>
        )}
      </div>
      <div className="orderSummaryDiveder"></div>
      <div className="ord-sum-payment-section">
        <span className="tripInfo-title">
          {localize('preview-sales-engine.static-content.copy.pbeo.summary-payment-section-header')}
        </span>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.summary-payment-method-label')}
          </span>
          <span className="tripInfo-content">{cardInfo}</span>
        </div>
      </div>
      <div className="orderSummaryDiveder"></div>
      <div className="ord-sum-payment-section">
        <span className="tripInfo-title">
          {localize('preview-sales-engine.static-content.copy.pbeo.summary-price-detail-label')}
        </span>
        <div className="tripInfo-row-container">
          <span className="tripInfo-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.total-due-label')}
          </span>
          <span className="summary-totalPrice-text">{totalPriceAmt}</span>
        </div>
        <div className="tripInfo-row-container">
          <span className="summary-depositPaid-head">
            {localize('preview-sales-engine.static-content.copy.pbeo.summary-total-paid-label')}
          </span>
          <span className="summary-depositPaid-text">{depositPaidAmt}</span>
        </div>
        {orderInfo?.balance && (
          <div className="tripInfo-row-container">
            <span className="tripInfo-head">
              {localize('preview-sales-engine.static-content.copy.pbeo.due-at-booking-label')}
            </span>
            <span className="summary-totalPrice-text">{balanceAmt}</span>
          </div>
        )}
        <div className="orderSummaryDiveder"></div>
      </div>
    </>
  );
};
export default withLocalization(InformationSummary);
